module.exports = __webpack_public_path__ + "fontello.ad3de83b317fb7b6d52a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/assets/fonts/fontello/font/fontello.svg?38968230
// module id = ../../../../../src/assets/fonts/fontello/font/fontello.svg?38968230
// module chunks = 2